<template>
	<div>
		<h2 class="toptitle">
			<div>数据面板</div>
			<!-- <dv-digital-flop :config="countss" style="width:100px;height:50px;" /> -->
			<el-button icon="el-icon-refresh " class="shuaxin_icon" size="mini" @click="getdata(1)" circle></el-button>
		</h2>
		<!-- 数据统计 -->
		<el-row :gutter="20">
			<el-col :span="6" v-for="(item,index) in counts" :key="index">
				<el-card class="box-card aa" shadow="hover">
					<div class="">
						<!-- <i 
						:class="[item.icon,item.color]"
						class="h4 mb-0 text-white text-center mr-3"
						style="width: 40px;height: 40px;line-height: 40px;">
						</i> -->
						<div>
							<div class="numbs">{{item.num}}</div>
							<div class="numbs_text">{{item.desc}}</div>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<!-- 快捷操作 -->
		<el-row :gutter="20" class="mt-3">
			<el-col :span="24" class="d-flex flex-column" style="justify-content: space-between;">

				<el-card class="box-card" shadow="never" v-for="(tip,ti) in kkcz" :key="ti">
					<div slot="header" class="clearfix">
						<span>{{tip.title}}</span>
						<el-button style="float: right; padding: 3px 0" type="text">{{tip.desc}}</el-button>
					</div>
					<div class="row">
						<div :class="tip.list.length|getCol" v-for="(tlist,listi) in tip.list" :key="listi">
							<button class="btn btn-light w-100" @click="gopage(tlist.id)">
								<!-- <h4 class="mb-1">{{tlist.value}}</h4> -->
								<div>
									<i style="font-size:30px" :class="tlist.icon" :style="'color:'+tlist.color"></i>
								</div>
								<small class="text-muted">
									{{tlist.name}}</small>
							</button>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<!-- 待处理事务 -->
		<el-row :gutter="20" class="mt-3">
			<el-col :span="24" class="d-flex flex-column" style="justify-content: space-between;">
				<el-card class="box-card" shadow="never" v-for="(tip,ti) in dclsw" :key="ti">
					<div slot="header" class="clearfix">
						<span>{{tip.title}}</span>
						<el-button style="float: right; padding: 3px 0" type="text">{{tip.desc}}</el-button>
					</div>
					<div class="row">
						<div :class="tip.list.length|getCol" v-for="(tlist,listi) in tip.list" :key="listi">
							<button class="btn btn-light w-100" @click="gopage(tlist.id)">
								<div class="numbs2">{{tlist.value}}</div>
								<small class="text-muted">
									{{tlist.name}}</small>
							</button>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<!-- 总览 -->
		<el-row :gutter="20" class="my-3">
			<el-col :span="12">
				<el-card class="box-card" shadow="never" v-for="(tip,ti) in yhzl" :key="ti">
					<div slot="header" class="clearfix">
						<span>{{tip.title}}</span>
						<el-button style="float: right; padding: 3px 0" type="text">{{tip.desc}}</el-button>
					</div>
					<div class="row">
						<div :class="tip.list.length|getCol" v-for="(tlist,listi) in tip.list" :key="listi">
							<button class="btn btn-light w-100">
								<h4 class="mb-1">{{tlist.value}}</h4>
								<small class="text-muted">
									{{tlist.name}}</small>
							</button>
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card class="box-card" shadow="never" v-for="(tip,ti) in yszl" :key="ti">
					<div slot="header" class="clearfix">
						<span>{{tip.title}}</span>
						<el-button style="float: right; padding: 3px 0" type="text">{{tip.desc}}</el-button>
					</div>
					<div class="row">
						<div :class="tip.list.length|getCol" v-for="(tlist,listi) in tip.list" :key="listi">
							<button class="btn btn-light w-100">
								<h4 class="mb-1">{{tlist.value}}</h4>
								<small class="text-muted">
									{{tlist.name}}</small>
							</button>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import xaoi from '../../common/xaoi'
	import router from "../../router";
	export default {
		data() {
			return {
				xaoi,
				counts: [{
						icon: "el-icon-user-solid",
						desc: "咨询总量",
						num: "0",
						color: "bg-primary"
					},
					{
						icon: "el-icon-s-finance",
						desc: "咨询费用总额(元)",
						num: "0",
						color: "bg-success"
					},
					{
						icon: "el-icon-s-order",
						desc: "商城消费总额(元)",
						num: "0",
						color: "bg-danger"
					},
					{
						icon: "el-icon-s-data",
						desc: "知识付费总额(元)",
						num: "0",
						color: "bg-warning"
					},
				],
				kkcz: [{
					title: "快捷操作",
					desc: "",
					list: [{
							name: "咨询订单管理",
							value: "64",
							id: 1,
							icon: 'el-icon-s-order',
							color: '#22bcca'
						},
						{
							name: "⽤户管理",
							value: "10",
							id: 2,
							icon: 'el-icon-user-solid',
							color: '#ff9f24'
						},
						{
							name: "医⽣审核",
							value: "0",
							id: 3,
							icon: 'el-icon-s-claim',
							color: '#8097eb'
						},
					]
				}, ],
				dclsw: [{
					title: "待处理事务",
					desc: "",
					list: [{
							name: "待审核医生",
							value: "0",
							id: 4
						},
						{
							name: "待处理提现",
							value: "0",
							id: 5
						},
						{
							name: "待审核订单",
							value: "0",
							id: 6
						},
						{
							name: "⼴告位即将到期",
							value: "0",
							id: 7
						},
					]
				}, ],
				yhzl: [{
					title: "用户总览",
					desc: "",
					list: [{
							name: "今日新增",
							value: "0"
						},
						{
							name: "本周新增",
							value: "0"
						},
						{
							name: "本月新增",
							value: "0"
						},
						{
							name: "用户总量",
							value: "0"
						},
					]
				}, ],
				yszl: [{
					title: "医生总览",
					desc: "",
					list: [{
							name: "今日新增",
							value: "0"
						},
						{
							name: "本周新增",
							value: "0"
						},
						{
							name: "本月新增",
							value: "0"
						},
						{
							name: "用户总量",
							value: "0"
						},
					]
				}, ],
				countss: {
					number: [100],
					content: '{nt}',
				},

			}
		},
		filters: {
			getCol(total) {
				return `col-${12/total}`;
			}
		},
		// dom渲染完毕
		mounted() {

			this.connect()
			this.getdata()
			// this.aa()
		},
		methods: {
			aa() {
				for (let i = 0; i < 7100; i++) {
					setTimeout(() => {
						this.countss++
					}, 0)
				}
			},
			getdata(t) {
				axios.post('/admin/pc/homepage/homePageData', {}, {
					token: true
				}).then(res => {
					if (res.data.code == 200) {
						if (t == 1) {
							this.$message.success('刷新成功！')
						}
					}
				})
			},
			async connect() {
				let that = this
				that.$openws.ws.homePage = function (text, type) {
					if (text.msg_source == 'homePage') {
						if (text.modular == 'inquiry') {
							that.counts[0].num = text.data.total_count ? text.data.total_count : '0'
							that.counts[1].num = text.data.total_price ? text.data.total_price : '0'
						}
						if (text.modular == 'mall') {
							that.counts[2].num = text.data.total_price ? text.data.total_price : '0'
						}
						if (text.modular == 'audit') {
							that.dclsw[0].list[0].value = text.data.count ? text.data.count : '0'
						}
						if (text.modular == 'pretax') {
							that.dclsw[0].list[1].value = text.data.total_count ? text.data.total_count : '0'
						}
						if (text.modular == 'mallDeliver') {
							that.dclsw[0].list[2].value = text.data.total_count ? text.data.total_count : '0'
						}
						if (text.modular == 'userRegister') {
							that.yhzl[0].list[0].value = text.data.user_day_count ? text.data.user_day_count : '0'
							that.yhzl[0].list[1].value = text.data.user_week_count ? text.data.user_week_count :
								'0'
							that.yhzl[0].list[2].value = text.data.user_month_count ? text.data.user_month_count :
								'0'
							that.yhzl[0].list[3].value = text.data.user_total_count ? text.data.user_total_count :
								'0'
						}
						if (text.modular == 'docRegister') {
							that.yszl[0].list[0].value = text.data.doc_day_count ? text.data.doc_day_count : '0'
							that.yszl[0].list[1].value = text.data.doc_week_count ? text.data.doc_week_count : '0'
							that.yszl[0].list[2].value = text.data.doc_month_count ? text.data.doc_month_count :
								'0'
							that.yszl[0].list[3].value = text.data.doc_total_count ? text.data.doc_total_count :
								'0'
						}
					}
				};
				// 接诊提醒
				that.$openws.ws.inquiryRemind = function (text, type) {
					this.$notify.info({
						title: '新咨询订单',
						message: text.data,
						position: 'bottom-right',
					});
				};

			},
			gopage(id) {
				if (id == 1) {
					this.$router.push('/table/mcn/cousult-mx')
				}
				if (id == 2) {
					this.$router.push('/user/user-list/list')
				}
				if (id == 3) {
					this.$router.push('/set/settle')
				}
				if (id == 4) {
					this.$router.push({
						path: '/set/settle',
						query: {
							type: 0
						}
					})
				}
				if (id == 5) {
					this.$router.push({
						path: '/Withdrawal/list',
						query: {
							type: 1
						}
					})
				}
				if (id == 6) {
					this.$router.push('/order/order/list')
				}
				if (id == 7) {
					this.$router.push('/set/adsense')
				}
			}
		},
		destroyed() {
			this.$openws.connect()
		},
	}
</script>

<style lang='scss' scoped>
	.toptitle {
		font-size: 30px;
		padding: 10px 0;
		display: flex;
		align-items: center;

		.shuaxin_icon {
			font-size: 12px;
			margin-left: 5px;
		}
	}

	.numbs {
		font-size: 20px;
		font-weight: 600;
		text-align: center;
		color: #5473e8;
	}

	.numbs_text {
		text-align: center;
		margin-top: 10px;
	}

	.numbs2 {
		color: red;
		font-size: 20px;
		font-weight: 600;
	}

	.aa,
	.btn-light {
		background-color: #f5f7fd;
	}
</style>